import { Alert, App, Spin } from "antd";
import { observer } from "mobx-react";
import { useMemo, useState, useEffect } from "react";
import { ChangePaymentDetailsModalContentPaddle } from ".";
import { __ } from "../../../../utils";
const ChangePaymentDetailsForm = observer(_ref => {
  let {
    record,
    onClose,
    refetch = true,
    showInfo = true
  } = _ref;
  const {
    message
  } = App.useApp();
  if (!record.data.ecommerceSystemSubscriptionId) {
    // Payment method can only be changed, if subscriptions is referenced in a ecommerce system
    return null;
  }
  const {
    humanReadablePaymentMethod
  } = record;
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    record.loadVendorScripts().then(() => setIsLoaded(true));
  }, [record]);
  const ExternalPaymentComponent = useMemo(() => {
    const name = "paddle"; // TODO: differ between eCommerce system
    switch (name.toLowerCase()) {
      case "paddle":
        return ChangePaymentDetailsModalContentPaddle;
      default:
        throw new Error(`${name} payment form not yet implemented!`);
    }
  }, [record]);
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: !isLoaded
  }, showInfo && /*#__PURE__*/React.createElement(Alert, {
    type: "info",
    showIcon: true,
    message: __("Please keep the payment details for your subscription up to date so that payments do not fail.")
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "10px 0"
    }
  }, __("You can pay by credit card (VISA, Mastercard, Maestro, American Express) or by PayPal (with account usually by direct debit or credit card).")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, __("Until now used payment method:")), " ", humanReadablePaymentMethod), isLoaded && /*#__PURE__*/React.createElement(ExternalPaymentComponent, {
    record: record,
    onComplete: () => {
      if (refetch) {
        message.success(__("Successfully updated payment details!"));
        record.store.fetchSubscriptionsAndLicenses();
      }
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  }));
});
export { ChangePaymentDetailsForm };